import React from 'react';
import PropTypes from 'prop-types';

function InviteNotification({ message, url }) {
  const [first, second] = message.split('<a>');
  const [linkText, third] = (second || '').split('</a>');
  return (
    <span>
      {first}
      &nbsp;
      {linkText && (
        <a href={url} target="_blank" rel="noreferrer">
          {linkText}
        </a>
      )}
      &nbsp;
      {third}
    </span>
  );
}

InviteNotification.propTypes = {
  message: PropTypes.string,
  url: PropTypes.string,
};

InviteNotification.defaultProps = {
  message: '',
  url: 'https://staging.hellohaptik.com/admin_tools/permissions/',
};

export default InviteNotification;
